import inViewport from "in-viewport";

import { $$, Debuggable } from '@gebruederheitz/wp-frontend-utils';

export class EmailObfuscationFactory {
    constructor(selector = '[data-ghwp-maillink]', debug = false) {
        $$()(selector).forEach(element => {
            if (debug) {
                console.log('Initializing email address  de-obfuscation for element', element);
            }
            new EmailObfuscation(element, debug);
        });
    }
}

export class EmailObfuscation extends Debuggable {
    constructor(anchor, debug = false) {
        super('EmailObfuscation');

        this.root = anchor;
        this.options = {
            debug
        };

        this.onClick = this.onClick.bind(this);
        this.onVisible = this.onVisible.bind(this);

        const rawAddress = this.root.dataset.ghwpMaillink;
        const rawSubject = this.root.dataset.ghwpMailsubject || '';

        if (!anchor.matches('a') || !rawAddress) {
            this.debug.log('Root element does not qualify, aborting.', {anchor});
            return;
        }
        this.address = atob(rawAddress);
        this.subject = atob(rawSubject);

        this.listen();

        if (this.root.dataset.ghwpDecodeDisplay) {
            this.scrollListen();
        }

    }

    listen() {
        this.root.addEventListener('click', this.onClick);
    }

    onClick() {
        this.debug.log('Setting mailto address on element', {
            element: this.root,
            address: this.address,
            subject: this.subject,
        });
        this.root.href = 'mailto:' + this.address + '?subject=' + this.subject;
    }

    onVisible() {
        this.debug.log('in viewport!', {root: this.root, address: this.address});
        this.root.innerText = this.address;
    }

    scrollListen() {
        inViewport(this.root, this.onVisible);
    }
}
